import Marquee from "react-fast-marquee";
import { Stamp } from "lucide-react";

const ITEMS = [
  "Handwritten",
  "High Conversion",
  "Physical Touch",
  "No Robots",
  "Zero Spam Filters",
  "USPS Delivered",
  "Warm Openings",
  "Real ROI",
];

export const EditorialMarquee = () => {
  return (
    <section
      className="relative border-y border-[#E4DFD4] bg-[#EFECE5] py-8 overflow-hidden"
      data-testid="marquee-section"
    >
      <Marquee
        speed={40}
        gradient={false}
        pauseOnHover
        aria-label="brand values marquee"
      >
        {[...ITEMS, ...ITEMS].map((word, i) => (
          <span
            key={i}
            className="inline-flex items-center gap-6 mx-6 font-serif-display text-[#1C1C1A] text-4xl md:text-6xl italic tracking-tight"
          >
            {word}
            <Stamp size={28} className="text-[#D93829] mx-4 not-italic" />
          </span>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
